import { motion } from "framer-motion";
import { PROCESS } from "@/lib/site";
import { Reveal } from "./Reveal";

export const Process = () => {
  return (
    <section id="process" data-testid="process" className="py-24 lg:py-32 bg-navy relative overflow-hidden grain">
      <div className="blob w-[420px] h-[420px] bg-brand/20 -top-20 right-10" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald mb-4">03 — How It Works</p>
          <h2 className="font-display font-extrabold text-white tracking-tight text-4xl md:text-5xl max-w-2xl leading-[1.05]">
            Six clear steps from enquiry to disbursement.
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute left-0 right-0 top-[34px] h-px bg-white/10" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
            {PROCESS.map((p, i) => (
              <motion.div
                key={p.step}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="relative"
                data-testid={`process-step-${i}`}
              >
                <div className="grid place-items-center w-[68px] h-[68px] rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm font-display font-black text-2xl text-emerald">
                  {p.step}
                </div>
                <h3 className="mt-5 font-display font-bold text-lg text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-white/50 leading-relaxed">{p.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
